import { AxiosRequestConfig } from 'axios';
import API from 'services/api.js';
import { URL_GET_WEIGHT_CHART } from 'services/urls.js';

export type C3Array = [string, ...(number | null)[]];

export const actionFetchWeightChartData = (
	sessionId: number,
	timePeriod: string,
	includeCurrentDay: boolean,
	showOnlySession: boolean,
	showMessage: (msg: string) => void,
	setLoading: (l: boolean) => void
): Promise<C3Array[]> => {
	const params: AxiosRequestConfig = {
		params: {
			sessionId: sessionId,
			timePeriod: timePeriod,
			includeCurrentDay: includeCurrentDay,
			onlyShowSession: showOnlySession,
		},
		headers: {
			'x-opw-format': 'c3',
		},
	};
	return API.get(URL_GET_WEIGHT_CHART, params)
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			showMessage('Err fetching weight chart data: ' + error);
			return [];
		})
		.then((resp) => {
			setLoading(false);
			return resp;
		});
};

export const getDownloadFile = async (
	sessionId: number,
	timePeriod: string,
	includeCurrentDay: boolean,
	showOnlySession: boolean
): Promise<string> => {
	const params: AxiosRequestConfig = {
		params: {
			sessionId: sessionId,
			timePeriod: timePeriod,
			includeCurrentDay: includeCurrentDay,
			onlyShowSession: showOnlySession,
		},
		responseType: 'blob',
		timeout: 30000,
		headers: {
			'x-opw-format': 'csv',
		},
	};
	return API.get(URL_GET_WEIGHT_CHART, params).then((resp) => {
		return resp.data;
	});
};
